import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-single-input',
  templateUrl: './single-input.component.html',
  styleUrls: ['./single-input.component.css']
})
export class SingleInputComponent implements OnInit {

  icon: string;
  headline: string;
  subTitle: string;
  highlighted: string;
  label: string;
  placeholder: string;
  buttonText: string;

  value: string = "";

  constructor(
    private ref: MatDialogRef<SingleInputComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SingleInputData
  ) {
    this.icon = data.icon;
    this.headline = data.headline;
    this.subTitle = data.subTitle;
    this.highlighted = data.highlighted;
    this.label = data.label;
    this.placeholder = data.placeholder;
    this.buttonText = data.buttonText;
    if(data.presetted) this.value = data.presetted;
  }

  cancel(){
    this.ref.close();
  }

  ngOnInit(): void {
  }

  submit(){
    this.ref.close(this.value);
  }

}

export class SingleInputData {
  public icon: string;
  public headline: string;
  public subTitle: string;
  public highlighted: string;
  public label: string;
  public placeholder: string;
  public buttonText: string;
  public presetted: string;
}